import type { ProductDetail } from './product-detail';

export const productDetails: ProductDetail[] = [
    {
        ProductID: 1,
        Field: 'QuantityPerUnit',
        OldValue: '12 boxes x 24 bags',
        NewValue: '10 boxes x 20 bags',
    },
    {
        ProductID: 1,
        Field: 'UnitPrice',
        OldValue: '25.0',
        NewValue: '18.0',
    },
    {
        ProductID: 2,
        Field: 'Supplier',
        IsLocked: true,
        OldValue: 'Adam',
        NewValue: 'Dan',
    },
    {
        ProductID: 2,
        Field: 'UnitPrice',
        OldValue: '18.5',
        NewValue: '19.0',
    },
    {
        ProductID: 2,
        Field: 'UnitsInStock',
        OldValue: '5',
        NewValue: '17',
    },
    {
        ProductID: 2,
        Field: 'Discontinued',
        IsLocked: true,
        OldValue: 'true',
        NewValue: 'false',
    },
    {
        ProductID: 3,
        Field: 'Discontinued',
        IsLocked: true,
        OldValue: 'false',
        NewValue: 'true',
    },
    {
        ProductID: 3,
        Field: 'UnitsInStock',
        IsLocked: true,
        OldValue: '7',
        NewValue: '5',
    },
];
